import type { PlayerPosition } from "@/lib/demo-parser";
import { BOMB_COLOR, CT_COLOR, T_COLOR } from "./colors";

export function drawPlayers(
  ctx: CanvasRenderingContext2D,
  players: PlayerPosition[],
  flashedPlayers: Set<string>,
  toScreenX: (x: number) => number,
  toScreenY: (y: number) => number
) {
  players.forEach((player) => {
    if (!player.isAlive) return;

    const sx = toScreenX(player.x);
    const sy = toScreenY(player.y);
    const isFlashed = flashedPlayers.has(player.steamId);

    // Flash overlay (boltobserv inset white glow)
    if (isFlashed) {
      const flashPulse = 0.5 + Math.sin(Date.now() * 0.01) * 0.3;
      ctx.fillStyle = `rgba(255, 255, 255, ${flashPulse * 0.4})`;
      ctx.beginPath();
      ctx.arc(sx, sy, 20, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = `rgba(255, 255, 255, ${flashPulse})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(sx, sy, 18, 0, Math.PI * 2);
      ctx.stroke();
    }

    // Bomb carrier: orange ring glow behind the dot
    if (player.hasBomb) {
      ctx.strokeStyle = "rgba(255, 130, 0, 0.6)";
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.arc(sx, sy, 16, 0, Math.PI * 2);
      ctx.stroke();
    }

    // Player dot — boltobserv colors; orange for bomb carrier
    const color = player.hasBomb ? BOMB_COLOR : player.team === 3 ? CT_COLOR : T_COLOR;
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(sx, sy, 12, 0, Math.PI * 2);
    ctx.fill();

    // Thin dark inner stroke
    ctx.strokeStyle = "rgba(0, 0, 0, 0.50)";
    ctx.lineWidth = 1.5;
    ctx.stroke();

    // Direction indicator line
    const dirLength = 20;
    const angleRad = (player.viewX * Math.PI) / 180;
    const dirX = Math.cos(angleRad) * dirLength;
    const dirY = -Math.sin(angleRad) * dirLength;

    ctx.strokeStyle = "rgba(255, 255, 255, 0.8)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(sx + dirX, sy + dirY);
    ctx.stroke();

    // HP bar
    const barWidth = 30;
    const barHeight = 4;
    const hpPercent = Math.max(0, Math.min(1, player.hp / 100));

    ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
    ctx.fillRect(sx - barWidth / 2, sy - 20, barWidth, barHeight);

    ctx.fillStyle = hpPercent > 0.5 ? "#22c55e" : hpPercent > 0.25 ? "#eab308" : "#ef4444";
    ctx.fillRect(sx - barWidth / 2, sy - 20, barWidth * hpPercent, barHeight);

    // Player name
    ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
    ctx.font = "11px sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(player.name, sx, sy - 25);

    // Flashed indicator
    if (isFlashed) {
      const flashPulse = 0.5 + Math.sin(Date.now() * 0.01) * 0.3;
      ctx.fillStyle = `rgba(255, 255, 255, ${flashPulse})`;
      ctx.font = "bold 10px sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("FLASHED", sx, sy - 35);
    }
  });
}
